import React from 'react'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import { Navigation } from "swiper";

export const categories = [
    { name: 'New' },
    { name: 'Javascript', },
    { name: 'Coding',},
    { name: 'ReactJS' },
    { name: 'NextJS',},
    { name: 'Music', },
    { name: 'Education',  },
    { name: 'Podcast',  },
    { name: 'Movie',  },
    { name: 'Gaming',  },
    { name: 'Live',  },
    { name: 'Sport', },
    { name: 'Fashion',  },
    { name: 'Beauty',  },
    { name: 'Comedy', },
    { name: 'Gym',  },
    { name: 'Crypto', },
  ];


const Scroller = ({selectedCategory,setSelectedCategory}) => {
  return (
    <div className='hstack'>
        
        <Swiper navigation={true} modules={[Navigation]}  
        
         pagination={{ clickable: true }}
      
      
        breakpoints={{
            0:{slidesPerView:3,
                spaceBetween:5
            },
            400:{
                slidesPerView:3,
                spaceBetween:5,
            },
            600:{
                slidesPerView:5,
                spaceBetween:5,
            },
            800:{
                slidesPerView:7,
                spaceBetween:5,
            },
            1000:{
                slidesPerView:9,
                spaceBetween:5,
            },
            1200:{
                slidesPerView:10,
                spaceBetween:5,
            },
            1400:{
                slidesPerView:13,
                spaceBetween:5,
            },
            


        }}
        className="mySwiper ">
        <div className=''>
            {
                categories && categories.map((cat ,index)=>{
                    return(
                      <SwiperSlide key={index}>
                        <button className='btn category-btn' style={{ background : cat.name===selectedCategory && '#FC1503',
                    color:"black"}} onClick={()=>setSelectedCategory(cat.name)}>
                        <h5  style={{opacity:cat.name===selectedCategory ? '1':'0.7'}}>{cat.name} </h5>
                        </button>
                               
                      </SwiperSlide>
                    )
                })
            }
        </div>
       
      </Swiper>
    </div>
  )
}

export default Scroller
